// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1s0IP","savePackageButton":"ClientWallet_savePackageButton__7k2OJ"};